import { useI18n } from '../i18n'
import { useSession } from '../store/session'

type Tab = 'session' | 'journal' | 'dialogs'

export function TabBar() {
  const { t } = useI18n()
  const screen = useSession((s) => s.screen)
  const flowScreen = useSession((s) => s.flowScreen)
  const go = useSession((s) => s.go)

  const active: Tab =
    screen === 'journal' ? 'journal' : screen === 'dialogs' || screen === 'room' ? 'dialogs' : 'session'

  const navTo = (tab: Tab) => {
    if (tab === 'session') go(flowScreen)
    else if (tab === 'journal') go('journal')
    else go('dialogs')
  }

  return (
    <nav id="tabbar">
      <button className={'tab' + (active === 'session' ? ' act' : '')} onClick={() => navTo('session')}>
        <svg viewBox="0 0 24 24">
          <path d="M3 15 L7 6 L11 18 L15 8 L17 12 C 19 8, 21 10, 21 13" />
        </svg>
        {t.nav.draw}
      </button>
      <button className={'tab' + (active === 'journal' ? ' act' : '')} onClick={() => navTo('journal')}>
        <svg viewBox="0 0 24 24">
          <path d="M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3z" />
          <path d="M9 9h6M9 13h6" />
        </svg>
        {t.nav.journal}
      </button>
      <button className={'tab' + (active === 'dialogs' ? ' act' : '')} onClick={() => navTo('dialogs')}>
        <svg viewBox="0 0 24 24">
          <path d="M4 6h16v10H9l-5 4z" />
        </svg>
        {t.nav.dialogs}
      </button>
    </nav>
  )
}
